import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pen-icon",
  "use": "pen-icon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"pen-icon\"><path d=\"M12 19h8M16 4.544a1.9 1.9 0 0 1 2.055-.403 1.888 1.888 0 0 1 1.02 1.006 1.835 1.835 0 0 1-.408 2.026L7.556 18.123 4 19l.889-3.504L16 4.544Z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol